// swiper bundle styles
// swiper bundle styles
import 'swiper/css/bundle'
import 'swiper/css'
import 'swiper/css/navigation'
import Swiper, { Navigation } from 'swiper';

/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
//スライダー
const swiper1 = new Swiper(".swiper-pickup", {
    modules: [Navigation],
    loop: true,
    autoplay: {
        delay: 3500,
    },
    speed: 1100,
    slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const swiper2 = new Swiper(".swiper-carousel", {
	modules: [Navigation],
	loop: true,
	autoplay: {
		delay: 3500,
	},
	speed: 1100,
	slidesPerView: 2,
	centeredSlides: true,
	spaceBetween: 10,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	breakpoints: {
		320: {
			slidesPerView: 2.15,
		},
		480: {
			slidesPerView: 2.7,
		},
		576: {
			slidesPerView: 1.9,
		},
		600: {
			slidesPerView: 2.1,
		},
		650: {
			slidesPerView: 2.3,
		},
		700: {
			slidesPerView: 2.5,
		},
		750: {
			slidesPerView: 2.7,
		},
		820: {
			slidesPerView: 2.9,
		},
		870: {
			slidesPerView: 3.1,
		},
		920: {
			slidesPerView: 3.3,
		},
		970: {
			slidesPerView: 3.5,
		},
		1020: {
			slidesPerView: 3.7,
		},
		1084: {
			slidesPerView: 3.9,
		},
	},
});